var React = require('react');

function SnellIconTimetableSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .snell-icon-timetable-small {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Path_1277","data-name":"Path 1277","className":"snell-icon-timetable-small","d":"M3.36,7.5V21H23.52V7.5ZM21.84,3H25.2a1.509,1.509,0,0,1,1.68,1.5v18A1.509,1.509,0,0,1,25.2,24H1.68A1.509,1.509,0,0,1,0,22.5V4.5A1.509,1.509,0,0,1,1.68,3H5.04V1.5A1.509,1.509,0,0,1,6.72,0,1.509,1.509,0,0,1,8.4,1.5V3H18.48V1.5A1.509,1.509,0,0,1,20.16,0a1.509,1.509,0,0,1,1.68,1.5ZM20.16,18H16.8V15h3.36Zm-5.04,0H11.76V15h3.36Zm5.04-4.5H16.8v-3h3.36Zm-5.04,0H11.76v-3h3.36ZM10.08,18H6.72V15h3.36Z","transform":"translate(-17581.772 633)","key":1})]);
}

SnellIconTimetableSmall.defaultProps = {"viewBox":"-17581.771 633 26.879 24"};

module.exports = SnellIconTimetableSmall;

SnellIconTimetableSmall.default = SnellIconTimetableSmall;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=SnellIconTimetableSmall!./src/assets/images/icon_timetable_small.svg
// module id = 944
// module chunks = 1